module.exports = __webpack_public_path__ + "img/qian-three.55eeedc4.png";